import { useMutation } from "@tanstack/react-query";
import { impersonationMethods } from "../../api/apiMethods";
import { Logger } from "../../utils/logger/Logger";

export const useCreateLoginGrantMutation = (options: {
    onSuccess?: (code: string) => void;
    onError?: (error: any) => void;
}) => {
    const mutation = useMutation({
        mutationFn: async (input: LoginGrantInput) => {
            if (!input.municipalityId) {
                throw new Error("No municipality Id");
            }

            let code: string | undefined;

            try {
                code = (
                    await impersonationMethods(
                        input.municipalityId
                    ).getImpersonationCode(input.customerId)
                ).code;

                if (!code) {
                    throw new Error(
                        "Could not create login grant. No code was returned"
                    );
                }
            } catch (err) {
                throw err;
            }

            return code;
        },
        onSuccess: options.onSuccess,
        onError: async (error: Response) => {
            Logger.error(error);

            let parsedError;
            try {
                parsedError = await error.json();
            } catch {}

            options.onError?.(parsedError);
        },
    });

    return mutation;
};

interface LoginGrantInput {
    municipalityId: string;
    customerId: string;
}
